
import {Enum} from '../../common/model/enum.model';

export class Genere extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): Genere[] {
    return [
      new Genere('M'),
      new Genere('F')
    ];
  }

}
